<template>
	<div>
		<header>
			<h1>Documentation</h1>
		</header>
		<div>
			<nav class="documentation__nav">
				<ul>
					<li><router-link
						:to="{name: 'documentationSection', params:{0: 'navigation'}}">Navigating Software</router-link>
					</li>
					<li><router-link
						:to="{name: 'documentationSection', params:{0: 'tutorials'}}">Tutorials</router-link></li>
					<li><router-link
						:to="{name: 'documentationSection', params:{0: 'roadmap'}}">Software Roadmap</router-link></li>
				</ul>
			</nav>
			<div id="documentation" class="documentation__content sections">
				<section id="navigation" class="section">
					<header>
						<h1>Navigating Software</h1>
					</header>
					<div class="documentation__content__knowledge">
						<div class="editorial documentation__content__knowledge__copy">
							<p>The software is comprised of various section. The following list describes each of these sections.</p>
							<dl class="documentation__content__knowledge__list">
								<dt>Dashboard</dt>
								<dd>Top level information management</dd>
								<dt>Calendar</dt>
								<dd>Built in calendar for booking and organising your appointments, viewing any call backs scheduled against your leads.</dd>
								<dt>Clients</dt>
								<dd>Lead and instructions grouped by the client.</dd>
								<dt>Commissions</dt>
								<dd>Commissions owed to you or you owe to others, based on introductions made and that have subsequently been converted.</dd>
								<dt>Instructions</dt>
								<dd>Business that has been converted and accepted by you as a service provider. i.e an appointment booked with the client. From here converted business can be marked as complete and any sales values added for commission tracking.</dd>
								<dt>Introductions</dt>
								<dd>Introductions that you have made to other service providers. From here you can see the status of the introduction and any activity.</dd>
								<dt>Leads</dt>
								<dd>New incoming leads/prospective customers that require attention or have had no action made against them.</dd>
								<dt>Settings</dt>
								<dd>Configuration of how you want leads and instructions to be managed within your business.</dd>
								<dt>Teams</dt>
								<dd>Internal teams can be setup to manage volume or different types of leads and instructions.</dd>
								<dt>Users</dt>
								<dd>View or add new users to your company profile.</dd>
								<dt>Offers</dt>
								<dd>Where you can add offers available to potential clients. These can be changed, updated and removed at any time. (currently only available to estate agents)</dd>
							</dl>
						</div>
					</div>
				</section>
				<section id="tutorials" class="section">
					<header>
						<h1>Tutorials</h1>
					</header>
					<section>
						<header>
							<h2>Make An Introduction</h2>
						</header>
						<div class="documentation__content__knowledge">
							<div class="editorial documentation__content__knowledge__copy">
								<p>Introduce a new client to other network members couldn't be mor simple. Follow these few steps or watch the tutorial video.</p>
								<p>Once you have made the introduction, you will be redirected to the introduction page where you will see that the client will need to opt-in.</p>
								<p>The client will have received an email that contains an opt-in link and once they have done so, the introduction page will automatically update.</p>
							</div>
							<div class="documentation__content__knowledge__example">
								<ol class="documentation__steps-list">
									<li>Navigate to the introductions page</li>
									<li>Click 'create introduction'</li>
									<li>Fill in the client details</li>
									<li>Select the services that the client requires</li>
									<li>Fill in any additional details required for each service</li>
									<li>Click 'create introduction'</li>
								</ol>
							</div>
						</div>
					</section>
				</section>
				<section id="roadmap" class="section">
					<header>
						<h1>Software Roadmap</h1>
					</header>
					<div class="editorial">
						<p>Find out what new software features and improvements are on the way.</p>
					</div>
				</section>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			pathMatch: null,
		};
	},

	created() {
		this.pathMatch = this.$route.params.pathMatch;

		const options = {
			container: "#documentation",
			easing: "ease-in",
			lazy: false,
			offset: -60,
			force: true,
			cancelable: true,
			x: false,
			y: true,
		};

		this.$scrollTo("#four", 200, options);
	},
};
</script>
